import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { toast } from 'sonner';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatNumber(num) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num?.toString() || '0';
}

export function formatPercent(num) {
  return `${num?.toFixed(1) || 0}%`;
}

export function formatDate(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

export function formatDateTime(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export const EMPTY_CELL = '—';

export function formatCellValue(value, placeholder = EMPTY_CELL) {
  if (value === null || value === undefined || value === '') return placeholder;
  return value;
}

export function getAdoptionColor(pct) {
  if (pct >= 30) return 'bg-success/100';
  if (pct >= 15) return 'bg-warning/100';
  return 'bg-muted';
}

export function getEngagementColor(depth) {
  if (depth >= 1.5) return 'text-success';
  if (depth >= 1.2) return 'text-warning';
  return 'text-muted-foreground';
}

// Twin rule, not twin code: eva_people states the same rule in its own
// eva_people/src/lib/apiError.js's errorMessage(). That one takes an already-parsed
// fetch body since that app has no shared API client; this one takes an axios error.
// The signatures differ on purpose — the rule must not. Change one, change the other.
export function parseErrorDetail(errorOrResponse) {
  const detail = errorOrResponse?.response?.data?.detail ?? errorOrResponse;
  if (typeof detail === 'string') return { message: detail };
  if (detail instanceof Error) return { message: detail.message || 'An error occurred' };
  if (detail?.message) return detail;
  if (Array.isArray(detail)) {
    return {
      message: detail
        .map((item) => item?.msg || item?.message || JSON.stringify(item))
        .join(', '),
    };
  }
  if (detail && typeof detail === 'object') {
    return { message: detail.detail || detail.error || JSON.stringify(detail) };
  }
  return { message: errorOrResponse?.message || 'An error occurred' };
}

export function showLimitError(detail, navigate, fallbackMsg, options = {}) {
  const parsed = parseErrorDetail(detail);
  const { message, upgrade_url, cta_label } = {
    ...parsed,
    ...(detail && typeof detail === 'object' ? detail : {}),
  };
  const canUseCta = options.canUseCta !== false;
  const roleAwareMessage = options.nonCtaMessage || 'Please wait until usage resets or contact an admin.';
  const msg = message || fallbackMsg || 'Limit reached';
  const description = upgrade_url && !canUseCta ? `${msg} ${roleAwareMessage}` : msg;

  toast.error(upgrade_url ? 'Limit Reached' : 'Error', {
    description,
    ...(upgrade_url && canUseCta ? {
      action: {
        label: cta_label || 'Upgrade',
        onClick: () => navigate ? navigate(upgrade_url) : (window.location.href = upgrade_url),
      },
      classNames: {
        actionButton: '!bg-red-600 !text-white !border !border-red-700 hover:!bg-red-700',
      },
    } : {}),
  });
  return description;
}
